module.exports = __webpack_public_path__ + "static/fallingperson-0efaa5be95872029f1eabc7dbcc29270.png";